const EXCEL_SHEET_NAME_MAX = 31;

/** Excel forbids these characters in sheet names and truncates at 31. */
export function excelSheetName(name: string): string {
    const sanitized = name.replace(/[:\\/?*[\]]/g, '').trim();
    return sanitized.slice(0, EXCEL_SHEET_NAME_MAX) || 'Sheet1';
}

/** Deduplicates sheet names case-insensitively, appending 2, 3, … as needed. */
export function uniqueExcelSheetNames(names: string[]): string[] {
    const used = new Set<string>();
    return names.map((name) => {
        let candidate = excelSheetName(name);
        let suffix = 2;
        while (used.has(candidate.toLowerCase())) {
            const extra = ` ${suffix}`;
            candidate = `${excelSheetName(name).slice(0, EXCEL_SHEET_NAME_MAX - extra.length)}${extra}`;
            suffix += 1;
        }
        used.add(candidate.toLowerCase());
        return candidate;
    });
}
